class SliderImage extends HTMLElement {
    constructor() {
        super();
        const swiper = new Swiper(this.querySelector('.swiper'), {
            // Optional parameters
            direction: 'horizontal',
            slidesPerView: 'auto',
            cssMode: true,
            // If we need pagination
            pagination: {
                el: this.querySelector('.swiper-pagination'),
            },
            freeMode: true,
            spaceBetween: 0,

            breakpoints: {
                749: {
                    cssMode: false,
                    spaceBetween: 30
                }
            },
            // Navigation arrows
            navigation: {
                nextEl: this.querySelector('.swiper-button-next'),
                prevEl: this.querySelector('.swiper-button-prev'),
            },

        });
    }
}

customElements.define('slider-image', SliderImage);



class SliderLogo extends HTMLElement {
    constructor() {
        super();
        const swiper = new Swiper(this.querySelector('.swiper'), {
            // Optional parameters
            direction: 'horizontal',

            // If we need pagination
            pagination: {
                el: this.querySelector('.swiper-pagination'),
            },
            cssMode: true,
            slidesPerView: 1,
            spaceBetween: 0,
            freeMode: true,
            breakpoints: {

                320: {
                    slidesPerView: 2.5,
                    spaceBetween: 0
                },

                700: {
                    slidesPerView: 3.5,
                    spaceBetween: 0
                },
                749: {
                    slidesPerView: 3.5,
                    cssMode: false
                },
                1100: {
                    cssMode: false,
                    slidesPerView: 4.3,
                    spaceBetween: 30
                },

                1400: {
                    cssMode: false,
                    slidesPerView: 4,
                    spaceBetween: 40
                }
            },
            // Navigation arrows
            navigation: {
                nextEl: this.querySelector('.swiper-button-next'),
                prevEl: this.querySelector('.swiper-button-prev'),
            },

        });
    }
}

customElements.define('slider-logo', SliderLogo);


class SliderText extends HTMLElement {
    constructor() {
        super();
        const swiper = new Swiper(this.querySelector('.swiper'), {
            // Optional parameters
            direction: 'horizontal',

            // If we need pagination
            pagination: {
                el: this.querySelector('.swiper-pagination'),
            },

            slidesPerView: 'auto',
            spaceBetween: 0,
            freeMode: true,
            cssMode: true,
            breakpoints: {

                320: {
                    spaceBetween: 0
                },

                700: {
                    spaceBetween: 0
                },
                749: {
                    cssMode: false,
                    spaceBetween: 30
                },
                1100: {
                    cssMode: false,
                    spaceBetween: 30
                },

                1400: {
                    cssMode: false,
                    spaceBetween: 40
                }
            },
            // Navigation arrows
            navigation: {
                nextEl: this.querySelector('.swiper-button-next'),
                prevEl: this.querySelector('.swiper-button-prev'),
            },

        });
    }
}

customElements.define('slider-text', SliderText);

class SliderType extends HTMLElement {
    constructor() {
        super();

        window.addEventListener("resize", this.start.bind(this))


        this.swiper = new Swiper(this.querySelector('.swiper'), {
            // Optional parameters
            direction: 'horizontal',

            // If we need pagination
            pagination: {
                el: this.querySelector('.swiper-pagination'),
            },
            cssMode: true,
            slidesPerView: 2,
            spaceBetween: 0,
            freeMode: true,
            breakpoints: {
                // when window width is >= 320px
                749: {
                    slidesPerView: 3,
                    spaceBetween: 20,
                    cssMode: false
                },
                // when window width is >= 480px
                990: {
                    slidesPerView: 'auto',
                    spaceBetween: 30,
                    cssMode: false
                }
            },
            // Navigation arrows
            navigation: {
                nextEl: this.querySelector('.swiper-button-next'),
                prevEl: this.querySelector('.swiper-button-prev'),
            },

        });

        if (window.innerWidth < 990) {
            document.querySelectorAll(".search-product-type").forEach((el) => {
                el.querySelector(".swiper-type").classList.remove("swiper");
                el.querySelector(".swiper-wrapper-type").classList.remove("swiper-wrapper");
                el.querySelectorAll(".swiper-slide-type").forEach((el) => {
                    el.classList.remove("swiper-slide");
                })
            })
        }



    }

    start() {
        if (window.innerWidth > 989) {
            document.querySelectorAll(".search-product-type").forEach((el) => {
                el.querySelector(".swiper-type").classList.add("swiper");
                el.querySelector(".swiper-wrapper-type").classList.add("swiper-wrapper");
                el.querySelectorAll(".swiper-slide-type").forEach((elem) => {
                    elem.classList.add("swiper-slide");
                })
            })

        }
        else {

            document.querySelectorAll(".search-product-type").forEach((el) => {

                el.querySelector(".swiper-type").classList.remove("swiper");
                el.querySelector(".swiper-wrapper-type").classList.remove("swiper-wrapper");
                el.querySelectorAll(".swiper-slide-type").forEach((el) => {
                    el.classList.remove("swiper-slide");
                })
            })
        }

    }
}

customElements.define('slider-type', SliderType);